import PageContainer from '@/components/PageContainer';

import { Link } from 'react-router-dom';
import { Alert, Button } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';
import Message from '@/components/Message';

interface Props {
  to: string;
}

const HomePage: FC<Props> = ({ to = '/login' }) => {
  return (
    <PageContainer title="homeTitle" description="homeDescription" titleProps={{ variant: 'h1', textAlign: 'center' }}>
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Link to={to}>
          <Button variant="contained">Get Started</Button>
        </Link>
        <Alert severity="info" sx={{ mt: 5 }}>
          <Message content="disclamer" />
        </Alert>
      </Box>
    </PageContainer>
  );
};

export default HomePage;
